import interpolate from "JS/utils/interpolation";

class BlockWPhotos {
    /**
     * @type {HTMLElement}
     */
    block;

    /**
     * @type {HTMLElement[]}
     */
    slides = [];

    /**
     * @type {HTMLElement[]}
     */
    images = [];

    /**
     * @type {DOMRect}
     */
    blockRect;

    inited = false;

    progress = 0;
    _slideIndex;

    get slideIndex() {
        return this._slideIndex;
    }

    set slideIndex(val) {
        if (val === this._slideIndex) {
            return;
        }
        this._slideIndex = val;
        this.onSlideIndexChange();
    }

    slideProgresses = [];
    smoothSlideProgresses = [];

    _isSticky = false;

    get isSticky() {
        return this._isSticky;
    }

    set isSticky(value) {
        this._isSticky = value;
        this.onStateChange();
    }

    constructor(block) {
        if (!block) {
            return;
        }

        this.block = block;
        this.slides = Array.from(this.block.querySelectorAll('.block-w-photo__slide'));
        this.images = Array.from(this.block.querySelectorAll('.block-w-photo__images'));

        if (!this.slides.length) {
            return;
        }

        this.slideProgresses = Array(this.slides.length).fill(0);
        this.smoothSlideProgresses = Array(this.slides.length).fill(0);

        this.setRect();
        this.checkSticky();
        this.setInactiveState();
         
        this.inited = true;
        this.block.classList.add('inited');
    }

    update() {   
        this.setRect();

        // if (!this.isInViewport()) {
        //     return;
        // }

        this.checkSticky();

        if (this.isSticky) {
            this.calculateProgress();
        }

        this.normaleProgress();
        this.setInactiveState();
        this.handleImages();
    }

    isInViewport() {
        return this.blockRect.top <= window.innerHeight + 400
            && this.blockRect.top + this.blockRect.height >= -400;
    }

    normaleProgress() {
        this.slideProgresses.forEach((p, i) => {
            this.smoothSlideProgresses[i] += (p - this.smoothSlideProgresses[i]) * 0.1;
        });
    }

    handleImages() {
        this.images.forEach((imageWrapper, index) => {
            const progress = this.smoothSlideProgresses[index] || 0;
            this.moveImages(imageWrapper, progress);
        });
    }

    moveImages(imageWrapper, progress) {
        // if(this.progress === progress) {
        //     return;
        // }

        const images = Array.from(imageWrapper.querySelectorAll('.block-w-photo__images-item'));
        const normalizedProgess = ((50 - progress) * 0.75).toFixed(1);
        images.forEach((image) => {
            //requestAnimationFrame(() => {
                image.style.transform = `translate3d(0, ${normalizedProgess}%, 0)`;
            //});
        });
    }

    calculateProgress() {
        this.progress = +(interpolate(this.blockRect.top, 0, window.innerHeight - this.blockRect.height, 0, 100)).toFixed(2);

        const percentage = +(100 / this.slides.length).toFixed(2);

        const slideIndex = Math.floor(this.progress / percentage);
        const calcProcess = +(interpolate(this.progress % percentage, 0, percentage, 0, 100)).toFixed(2);

        this.slideProgresses.forEach((p, i) => {
            if (i < slideIndex) {
                this.slideProgresses[i] = 100;
                return;
            }
            if (i > slideIndex) {
                this.slideProgresses[i] = 0;
                return;
            }
            this.slideProgresses[i] = calcProcess;
        });

        this.slideIndex = slideIndex;
    }

    setRect() {
        this.blockRect = this.block.getBoundingClientRect();
    }

    checkSticky() {
        this.isSticky = this.blockRect.top <= 0 && this.blockRect.top + this.blockRect.height >= window.innerHeight;
    }

    setInactiveState() {
        const isTop = this.blockRect.top > 0 && !this.isSticky;
        const isBottom = this.blockRect.top + this.blockRect.height < window.innerHeight && !this.isSticky;

        this.block.classList.remove(['inactive-top', 'inactive-bottom']);
        this.block.classList.toggle('inactive-top', isTop);
        this.block.classList.toggle('inactive-bottom', isBottom);

        if (this.isSticky) {
            return;
        }

        if (isTop) {
            this.progress = 0;
            this.slideProgresses = Array(this.slides.length).fill(0);
            this.slideIndex = 0;
        }

        if (isBottom) {
            this.progress = 100;
            this.slideProgresses = Array(this.slides.length).fill(100);
            this.slideIndex = this.slides.length - 1;
        }
    }

    onStateChange() {
        this.block.classList.toggle('is-sticky', this.isSticky);
    }

    onSlideIndexChange() {
        this.slides.forEach((slide, index) => {
            if (index === this.slideIndex) {
                slide.classList.remove('hide-bottom');
                slide.classList.remove('hide-top');
                return;
            }
            slide.classList.toggle('hide-bottom', this.slideProgresses[index] === 0);
            slide.classList.toggle('hide-top', this.slideProgresses[index] === 100);
        });

        this.images.forEach((image, index) => {
            if (index === this.slideIndex) {
                image.classList.remove('hide-bottom');
                image.classList.remove('hide-top');
                return;
            }
            image.classList.toggle('hide-bottom', this.slideProgresses[index] === 0);
            image.classList.toggle('hide-top', this.slideProgresses[index] === 100);
        });
    }
}

const initBlocksWithPhotos = () => {
    const blocks = Array.from(document.querySelectorAll('.block-w-photo'));

    if (!blocks.length) {
        return;
    }

    const initedBlocks = blocks.map(block => {
        return new BlockWPhotos(block);
    });

    const loop = () => {
        initedBlocks.forEach(b => b.update());
        requestAnimationFrame(loop);
    };

    loop();
};

(() => {
    initBlocksWithPhotos();
})();
